
export const projectImages = {
  project01: require('../../assets/images/project01-thumbnail.png'),
  project02: require('../../assets/images/project02-thumbnail.png')

};
